module.exports = __webpack_public_path__ + "img/igv-mobile-screenshot.48978738.png";